import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";
import { List, Radio, Skeleton, Space, Tooltip } from "antd";
import { BriefcaseIcon } from "assets/icons";
import { STORAGE_KEYS } from "constants/appConstant";
import { AuthInfo, getMe } from "stores/slices/auth";
import {
  doGetConversationPage,
  doUpdateConversation,
  getConversationList,
  setConversationList,
  setParamsConversation,
} from "stores/slices/conversation";
import { changeLayout } from "stores/slices/layout";
import {
  doGetWorkspacePage,
  doSwitchWorkspace,
  isSaving,
} from "stores/slices/workspace";
import { auth } from "useFirebase/firebase";
import {
  requestSignInWithCustomToken,
  requestSignOut,
} from "useFirebase/useFireStore";
import StorageHelper from "utils/storeHelper";

const SwitchWorkspace = props => {
  const { setIsOpenSwitchWorkspace } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authInfo = useSelector(AuthInfo);
  const loading = useSelector(isSaving);
  const [workspaceList, setWorkspaceList] = useState([]);
  const [queries, setQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
    statuses: "ACTIVE",
  });
  const [totalPages, setTotalPages] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setLoading] = useState(false);

  let conversationList = useSelector(getConversationList);

  const handleUnlockConversation = async () => {
    let request;
    if (conversationList && conversationList.length > 0) {
      conversationList.forEach(async conversationItem => {
        //  Unlock conversation
        if (
          authInfo?.id === conversationItem?.lockUserId &&
          conversationItem?.lock
        ) {
          request = {
            id: conversationItem?.id,
            lockConversation: false,
          };
          await dispatch(doUpdateConversation(request));
        }
      });
    }
  };

  const loadDataConversation = async data => {
    if (data && data.workspaceId) {
      const params = {
        workspaceId: data.workspaceId,
        pageNumber: 1,
        pageSize: 10,
        sortField: "sendTimeMessage",
        sortDirection: "ASC",
        filterConversation: "AWAITING_REPLIES",
      };
      const { payload } = await dispatch(doGetConversationPage(params));
      if (payload && payload.status === 200) {
        let newConversationList;
        newConversationList = [...payload.data.content];
        if (newConversationList && newConversationList.length > 0) {
          handleUnlockConversation(newConversationList);
          // Remove draft message from conversation list
          // handleRemoveDraftMessage(newConversationList);
        }
        await dispatch(setParamsConversation(params));
        await dispatch(setConversationList(newConversationList));
      }
    }
  };

  const handleSwitchWorkspace = async id => {
    handleUnlockConversation();
    if (id) {
      const request = {
        id: id,
      };
      const { payload } = await dispatch(doSwitchWorkspace(request));
      if (payload && payload.status === 200) {
        let pathNameUrl = window.location.pathname.split("/");
        const layout = StorageHelper.getLocalItem("layout");
        if (pathNameUrl[2] === "dashboard" && layout === "ADMIN") {
          await dispatch(changeLayout("ADMIN"));
          await requestSignOut(auth);
          await requestSignInWithCustomToken(auth, payload.data.fsToken);
          await dispatch(getMe());
        } else if (layout === "OPERATOR") {
          requestSignOut(auth);
          StorageHelper.removeLocalItem(STORAGE_KEYS.currentConversationId);
          StorageHelper.removeLocalItem(STORAGE_KEYS.filterStatusConversation);
          requestSignInWithCustomToken(auth, payload.data.fsToken);
          await dispatch(getMe());
          const user = JSON.parse(
            StorageHelper.getLocalItem(STORAGE_KEYS.user)
          );
          await loadDataConversation(user);
        } else {
          navigate("/admin/dashboard");
          await dispatch(changeLayout("ADMIN"));
          await requestSignOut(auth);
          await requestSignInWithCustomToken(auth, payload.data.fsToken);
          await dispatch(getMe());
        }
        if (setIsOpenSwitchWorkspace) {
          setIsOpenSwitchWorkspace(false);
        }
      }
    }
  };

  const loadMoreData = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
    };
    if (totalPages > 0 && request.pageNumber > totalPages) {
      setHasMore(false);
      return;
    }
    setHasMore(false);
    setLoading(true);
    const { payload } = await dispatch(doGetWorkspacePage(newRequest));
    if (
      payload &&
      typeof payload !== "string" &&
      payload.content &&
      payload.content.length > 0
    ) {
      let newList = [];
      newList = removeDuplicates([...workspaceList, ...payload.content]);
      setWorkspaceList(newList);
      setQueries(newRequest);
      setTotalPages(payload.totalPages);
    }
    setLoading(false);
  };

  const handleScroll = eve => {
    const clientHeight = eve.target.clientHeight;
    const scrollTop = eve.target.scrollTop;
    const scrollHeight = eve.target.scrollHeight;
    if (
      clientHeight + 20 - (scrollHeight - scrollTop) > 0 &&
      queries.pageNumber <= totalPages
    ) {
      setHasMore(true);
    }
  };

  const removeDuplicates = arr => {
    return arr.filter(
      (ele, ind) => ind === arr.findIndex(elem => elem.id === ele.id)
    );
  };
  useEffect(() => {
    if (authInfo.workspaceId) {
      loadMoreData({
        ...queries,
        statuses: "ACTIVE",
      });
    }
  }, []);

  return (
    <React.Fragment>
      <div className="switchWorkspaceContainer">
        <div className="switchWorkspaceHeader">
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <BriefcaseIcon />
            <span
              className="switchWorkspaceHeaderTitle"
              style={{
                marginBottom: 0,
                width: "300px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                marginLeft: 8,
              }}
            >
              {authInfo?.workspaceName}
            </span>
          </div>
          <Radio defaultChecked={true} />
        </div>
        <div>
          <div
            id="scrollableDiv"
            // style={{
            //   height: "auto",
            //   maxHeight: "200px",
            //   overflow: "auto",
            // }}
          >
            <InfiniteScroll
              dataLength={workspaceList.length}
              next={
                hasMore &&
                loadMoreData({
                  pageNumber:
                    workspaceList.length > 0
                      ? queries.pageNumber + 1
                      : queries.pageNumber,
                  pageSize: queries.pageSize,
                  statuses: "ACTIVE",
                })
              }
              hasMore={hasMore}
              height={200}
              loader={
                isLoading && (
                  <Skeleton
                    paragraph={{
                      rows: 1,
                    }}
                    active
                  />
                )
              }
              scrollableTarget="scrollableDiv"
              onScroll={handleScroll}
            >
              <div style={{ width: "100%" }}>
                <List
                  className="switchWorkspaceList"
                  loading={loading || isLoading}
                  itemLayout="horizontal"
                  dataSource={workspaceList}
                  renderItem={item => (
                    <List.Item
                      key={item.id}
                      style={{
                        width: "100%",
                        display:
                          item.id === authInfo.workspaceId ? "none" : "block",
                      }}
                      onClick={() => handleSwitchWorkspace(item.id)}
                    >
                      <Space
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{ marginRight: 8, marginTop: 4 }}
                            className="switchWorkspaceIcon"
                          >
                            <BriefcaseIcon />
                          </div>
                          <span
                            style={{
                              marginBottom: 0,
                              width: "300px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.name}
                          </span>
                        </div>

                        <Tooltip title={t("label.switchWorkspace")}>
                          <RightOutlined />
                        </Tooltip>
                      </Space>
                    </List.Item>
                  )}
                />
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SwitchWorkspace;
